import {
  ChatAlt2Icon,
  CheckIcon,
  ClipboardCheckIcon,
  FolderOpenIcon,
  OfficeBuildingIcon,
  UsersIcon,
  XIcon,
} from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "~/design-system/Box";
import { Heading } from "~/design-system/Heading";
import { useBreakpoint } from "~/design-system/hooks";
import { Icon } from "~/design-system/Icon";
import { Inline } from "~/design-system/Inline";
import { Stack } from "~/design-system/Stack";
import { Text } from "~/design-system/Text";
import { Toggle } from "~/design-system/Toggle";
import type { Filters } from "../../../../../../UserNotificationsScreen";

type CategoriesFilterProps = {
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filters: Filters;
};

const CategoriesFilter = (props: CategoriesFilterProps) => {
  const { t } = useTranslation();
  const { breakpoint } = useBreakpoint();
  const orgFilterLabel = t(
    "screens.UserNotificationsScreen.NotificationsFilter.org",
    "Org"
  );
  const taskFilterLabel = t(
    "screens.UserNotificationsScreen.NotificationsFilter.task",
    "Task"
  );
  const documentsFilterLabel = t(
    "screens.UserNotificationsScreen.NotificationsFilter.documents",
    "Documents"
  );
  const chatFilterLabel = t(
    "screens.UserNotificationsScreen.NotificationsFilter.chat",
    "Chat"
  );
  const projectFilterLabel = t(
    "screens.UserNotificationsScreen.NotificationsFilter.project",
    "Project"
  );

  return (
    <Stack space="medium">
      <Heading level="5" css={{ color: "$gray700" }}>
        {t(
          "screens.UserNotificationsScreen.NotificationsFilter.categoriess",
          "Categories"
        )}
      </Heading>
      <Inline space="gutter">
        <Toggle
          on={props.filters.categories.org}
          onChange={() => {
            const { categories, ...othersFilters } = props.filters;
            const { org, ...otherCategories } = categories;
            props.setFilters({
              categories: { org: !org, ...otherCategories },
              ...othersFilters,
            });
          }}
          onIcon={<CheckIcon />}
          offIcon={<XIcon />}
          align="left"
          width={breakpoint === "tablet" ? "auto" : "full"}
          justify="inherit"
          label={
            <Box display="flex" alignItems="center" gap="xxsmall">
              <Icon
                label={orgFilterLabel}
                size="small"
                css={{ overflow: "visible" }}
              >
                <UsersIcon />
              </Icon>
              <Text size="standard">{orgFilterLabel}</Text>
            </Box>
          }
        />
        <Toggle
          on={props.filters.categories.project}
          onChange={() => {
            const { categories, ...othersFilters } = props.filters;
            const { project, ...otherCategories } = categories;
            props.setFilters({
              categories: { project: !project, ...otherCategories },
              ...othersFilters,
            });
          }}
          onIcon={<CheckIcon />}
          offIcon={<XIcon />}
          align="left"
          width={breakpoint === "tablet" ? "auto" : "full"}
          justify="inherit"
          label={
            <Box display="flex" alignItems="center" gap="xxsmall">
              <Icon
                label={projectFilterLabel}
                size="small"
                css={{ overflow: "visible" }}
              >
                <OfficeBuildingIcon />
              </Icon>
              <Text size="standard">{projectFilterLabel}</Text>
            </Box>
          }
        />
        <Toggle
          on={props.filters.categories.task}
          onChange={() => {
            const { categories, ...othersFilters } = props.filters;
            const { task, ...otherCategories } = categories;
            props.setFilters({
              categories: { task: !task, ...otherCategories },
              ...othersFilters,
            });
          }}
          onIcon={<CheckIcon />}
          offIcon={<XIcon />}
          align="left"
          width={breakpoint === "tablet" ? "auto" : "full"}
          justify="inherit"
          label={
            <Box display="flex" alignItems="center" gap="xxsmall">
              <Icon
                label={taskFilterLabel}
                size="small"
                css={{ overflow: "visible" }}
              >
                <ClipboardCheckIcon />
              </Icon>
              <Text size="standard">{taskFilterLabel}</Text>
            </Box>
          }
        />
        <Toggle
          on={props.filters.categories.documents}
          onChange={() => {
            const { categories, ...othersFilters } = props.filters;
            const { documents, ...otherCategories } = categories;
            props.setFilters({
              categories: { documents: !documents, ...otherCategories },
              ...othersFilters,
            });
          }}
          onIcon={<CheckIcon />}
          offIcon={<XIcon />}
          align="left"
          width={breakpoint === "tablet" ? "auto" : "full"}
          justify="inherit"
          label={
            <Box display="flex" alignItems="center" gap="xxsmall">
              <Icon
                label={documentsFilterLabel}
                size="small"
                css={{ overflow: "visible" }}
              >
                <FolderOpenIcon />
              </Icon>
              <Text size="standard">{documentsFilterLabel}</Text>
            </Box>
          }
        />
        <Toggle
          on={props.filters.categories.chat}
          onChange={() => {
            const { categories, ...othersFilters } = props.filters;
            const { chat, ...otherCategories } = categories;
            props.setFilters({
              categories: { chat: !chat, ...otherCategories },
              ...othersFilters,
            });
          }}
          onIcon={<CheckIcon />}
          offIcon={<XIcon />}
          align="left"
          width={breakpoint === "tablet" ? "auto" : "full"}
          justify="inherit"
          label={
            <Box display="flex" alignItems="center" gap="xxsmall">
              <Icon
                label={chatFilterLabel}
                size="small"
                css={{ overflow: "visible" }}
              >
                <ChatAlt2Icon />
              </Icon>
              <Text size="standard">{chatFilterLabel}</Text>
            </Box>
          }
        />
      </Inline>
    </Stack>
  );
};

export { CategoriesFilter };
